export type CheckoutPayload = {
  service: ServicePick;
  addressId: string;
  address: AddressPick;
  preferredDate: string;
  preferredTime: string;
  paymentMethod?: 'online' | 'partial_base_fare' | 'cash_on_service';
  orderNotes?: string;
};

export type RichBlock =
  | { kind: 'hero'; icon: string; title: string; subtitle?: string; tone?: 'default' | 'success' | 'warning' | 'danger' }
  | { kind: 'section'; title: string }
  | { kind: 'check'; items: string[] }
  | { kind: 'kv'; rows: { label: string; value: string; highlight?: boolean }[]; dividerBefore?: string }
  | { kind: 'price'; label: string; value: string; sub?: string }
  | { kind: 'timeline'; steps: { label: string; status: 'done' | 'active' | 'pending' }[] }
  | { kind: 'alert'; tone: 'success' | 'warning' | 'danger' | 'info'; text: string }
  | { kind: 'progress'; percent: number; label?: string }
  | { kind: 'map'; label: string }
  | { kind: 'offer'; code: string; description: string }
  | { kind: 'otp'; code: string; status: string }
  | { kind: 'rating'; value: string; label?: string };

export type ChatAction =
  | { type: 'navigate'; path: string; label: string }
  | { type: 'link'; href: string; label: string }
  | { type: 'mailto'; email: string; label?: string }
  | { type: 'prompt'; label: string; message: string; description?: string; style?: 'chip' | 'card' | 'primary' }
  | { type: 'checkout'; label: string; checkout: CheckoutPayload };

export type AssistantRole = 'user' | 'assistant';

export type AssistantMessage = {
  id: string;
  role: AssistantRole;
  content: string;
  actions?: ChatAction[];
  rich?: RichBlock[];
  suggestions?: string[];
  timestamp: number;
};

export type RecentOrderSummary = {
  id: string;
  status: string;
  service?: string;
  placedAt?: string;
};

export type AssistantContext = {
  userName?: string;
  userId?: string;
  userPhone?: string;
  currentPath?: string;
  areaCity?: string;
  languageCode?: string;
  languageName?: string;
  recentOrders?: RecentOrderSummary[];
};

export type AssistantReply = {
  content: string;
  actions?: ChatAction[];
  rich?: RichBlock[];
  suggestions?: string[];
  source: 'local' | 'ai' | 'api';
};

export type ServicePick = {
  id: string;
  name: string;
  price: number;
};

export type AddressPick = {
  id: string;
  label: string;
  line: string;
  addressLine: string;
  city: string;
  state: string;
  zip: string;
  fullName?: string;
  phone?: string;
  lat?: string;
  long?: string;
};

export type OrderPick = {
  id: string;
  status: string;
  service?: string;
  address?: string;
  placedAt?: string;
};

export type AssistantFlow =
  | 'idle'
  | 'book_pick_service'
  | 'book_pick_address'
  | 'book_pick_schedule'
  | 'book_notes'
  | 'book_pick_payment'
  | 'book_confirm'
  | 'cancel_pick_order'
  | 'cancel_reason'
  | 'cancel_confirm'
  | 'review_pick_rating';

export type BookingPaymentChoice = 'online_full' | 'online_partial' | 'cash_on_service';

export type AssistantSession = {
  flow: AssistantFlow;
  serviceQuery?: string;
  serviceOptions?: ServicePick[];
  servicePage?: number;
  pickedService?: ServicePick;
  addressOptions?: AddressPick[];
  pickedAddress?: AddressPick;
  scheduledAt?: string;
  preferredTime?: string;
  bookingNotes?: string;
  paymentChoice?: BookingPaymentChoice;
  orderOptions?: OrderPick[];
  pickedOrder?: OrderPick;
  reviewOrder?: OrderPick;
  cancelReason?: string;
};

export const EMPTY_SESSION: AssistantSession = { flow: 'idle' };

export type AssistantTurnResult = {
  reply: AssistantReply;
  session: AssistantSession;
};
